module.exports = "pegasus_template/assets/header-default-1.jpg";